import gbAntFormItem from "./src/gb-ant-form-item.vue";
const gbAntFormItemCompenet = function(Vue) {
  Vue.component(gbAntFormItem.name, gbAntFormItem);
};
export default gbAntFormItemCompenet;
